import Icon, { IconName } from 'particles/Icon'
import styled, { useTheme } from 'particles/themes/styled'
import React from 'react'

export type PaymentIconType = 'creditCard' | 'bankTransfer'

interface PaymentIconProps {
    type: PaymentIconType
    isDisabled?: boolean
}

interface PaymentIconValue {
    color: string
    icon: IconName
}

const PaymentIcon: React.FC<PaymentIconProps> = ({ type, isDisabled = false }) => {
    const theme = useTheme()
    const iconMap: Record<PaymentIconType, PaymentIconValue> = {
        creditCard: {
            color: theme.colors.indicator.darkGreen,
            icon: 'creditCard',
        },
        bankTransfer: {
            color: theme.colors.indicator.yolkYellow,
            icon: 'bank',
        },
    }
    const { color, icon } = iconMap[type]
    return (
        <IconContainer color={isDisabled ? theme.colors.surface.disable : color}>
            <Icon name={icon} color="actionInverse" size="24px" />
        </IconContainer>
    )
}

interface IconContainerProps {
    color: string
}

const IconContainer = styled.div<IconContainerProps>`
    background: ${props => props.color};
    border-radius: 8px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
`

export default PaymentIcon
